import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { OrganizationMember } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { refreshMembersOnConflict } from './refresh-members-on-conflict';

export type SuspendOrganizationMemberParams = {
  organizationId: string;
  memberId: string;
};

export const suspendOrganizationMember = async (
  params: SuspendOrganizationMemberParams,
): Promise<OrganizationMember> => {
  return await tinctApi.organizationMembers.suspendMember(
    params.organizationId,
    params.memberId,
  );
};

export const useSuspendOrganizationMember = (
  options?: Omit<
    UseMutationOptions<OrganizationMember, ApiError, SuspendOrganizationMemberParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, onError, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: suspendOrganizationMember,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: ['organization-members', args[1].organizationId],
      });
      queryClient.invalidateQueries({
        queryKey: ['organization-member', args[1].organizationId, args[1].memberId],
      });
      onSuccess?.(...args);
    },
    onError: (...args) => {
      refreshMembersOnConflict(queryClient, args[0], args[1].organizationId);
      onError?.(...args);
    },
    ...restOptions,
  });
};
